<template>
	<div style="position: relative;box-sizing: border-box;padding: 10px;min-height: 100%;display: inline-block;"
		v-loading="loading">
		<v-jstree ref="jstree" size="small" text-field-name="name" value-field-name="id" :data="shoplist" collapse
			@item-click="itemClick" :klass="klass" v-if="shoplist.length!=0" :item-events="itemEvents"></v-jstree>
		<div>
			<contextmenu :contextMenuData="contextMenuData" @addNode="addNode" @editNode="editNode"
				@editKpi="editKpi" @deleteNode="deleteNode" @importgoodscode="importgoodscode"
				@cleargoodscode="cleargoodscode" v-if="menuShow">
			</contextmenu>
		</div>

		<add-index ref="addIndex" :nodeid="nodeid" :currentItem="currentItem" :sourceoperatedata="sourceoperatedata"
			@addsuccess="list" />

		<kpi-index ref="kpiIndex" :nodeid="nodeid" :currentItem="currentItem" :sourceoperatedata="sourceoperatedata"
			@addsuccess="list" />


		<importTable :ref="importRef" />

	</div>
</template>
<script>
	import VJstree from 'vue-jstree'
	import addIndex from './add/index.vue'
	import kpiIndex from './kpi/index.vue'
	import importTable from '@_system/components/import/index.vue'

	export default {
		props: {

		},
		data() {
			return {
				importRef: Math.random(),
				nodeid: 0,
				sourceoperatedata: [],
				menuActive: false,
				menuShow: false,
				klass: '',
				contextMenuData: {
					menuName: 'edgeMenu',
					axis: {
						x: null,
						y: null
					},
					menulists: [{
							btnName: "KPI配置",
							fnHandler: "editKpi",
							icoName: "el-icon-edit-outline"
						}, {
							btnName: "添加",
							fnHandler: "addNode",
							icoName: "el-icon-edit-outline"
						}, {
							btnName: "编辑",
							fnHandler: "editNode",
							icoName: "el-icon-edit-outline"
						},
						{
							btnName: "导入商品编码",
							fnHandler: "importgoodscode",
							icoName: "el-icon-edit-outline"
						},
						{
							btnName: "清空商品编码",
							fnHandler: "cleargoodscode",
							icoName: "el-icon-edit-outline"
						},
						{
							btnName: "删除",
							fnHandler: "deleteNode",
							icoName: "el-icon-delete"
						}
					]
				},
				loading: false,
				shoplist: [],
				currentObj: null,
				currentItem: {
					id: 0,
					name: ''
				},
				operationItem: null,
				itemEvents: {
					mouseover: (e) => {
						this.currentItem = e.model
						this.klass = 'menuoverClass'

					},
					mouseleave: () => {
						//console.log(e.model)
						this.klass = ''
					},
					contextmenu: (component, model, event) => {
						if (model.grouptype == 'operation') {
							this.onContextmenu(event, model)
						}
						event.preventDefault()
					}
				},
			}
		},

		created() {
			this.list()
		},
		mounted() {
			this.initImportConfig()
		},
		watch: {
			currentItem() {
				//this.menuShow = false
			}
		},
		computed: {

		},

		methods: {
			initImportConfig(){
				this.$refs[this.importRef].importcomfig = () => {
					return Promise.resolve([{
						title: '商品编码',
						require: true
					}])
				}
				this.$refs[this.importRef].importApi = () => {
					let data = this.$refs[this.importRef].importGetTableData()
					let goodscode = data.map((item) => {
						return item['商品编码']
					})
					this.$api.BIshopgoods.additemtogroup({
						nodeid: this.nodeid,
						goodscode: goodscode
					}).then(() => {
						this.$refs[this.importRef].importNoticeShow = false
						this.$emit('select', this.currentItem)
						this.$message.success('操作成功')
					})
				}
			},
			onContextmenu(event, model) {
				let items = [{
						label: "添加",
						onClick: () => {
							this.addNode()
						}
					}, {
						label: "编辑",
						disabled: model.id<=0,
						onClick: () => {
							this.editNode()
						}
					},{
						label: "KPI配置",
						disabled: model.id<=0,
						onClick: () => {
							this.editKpi()
						}
					}, {
						label: "导入商品编码",
						disabled: model.id<=0,
						onClick: () => {
							this.importgoodscode()
						}
					}, {
						label: "清空商品编码",
						disabled: model.id<=0,
						onClick: () => {
							this.cleargoodscode()
						}
					}, {
						label: "删除",
						disabled: model.id<=0,
						onClick: () => {
							this.deleteNode()
						},
					},
					// {
					// 	label: "删除",
					// 	disabled: true
					// }
				]
				this.$contextmenu({
					items: items,
					event,
					//x: event.clientX,
					//y: event.clientY,
					customClass: "custom-class",
					zIndex: 9999999,
					minWidth: 150
				});
				return false;
			},

			importgoodscode() {
				if (this.currentItem.id <= 0) {
					this.$message.error('根节点无法导入')
					return
				}
				this.nodeid = this.currentItem.id
				this.$refs[this.importRef].importpanel()
			},
			cleargoodscode() {
				if (this.currentItem.id <= 0) {
					this.$message.error('根节点无法清空')
					return
				}
				this.nodeid = this.currentItem.id
				this.$confirm('是否确认清空 ' + this.currentItem.name + ' 商品编码？').then(() => {
					this.$api.BIshopgoods.clearitemtogroup({
						nodeid: this.nodeid
					}).then(() => {
						this.$emit('select', this.currentItem)
						this.$message.success('操作成功')
					})
				})
			},
			editKpi() {
				this.nodeid = this.currentItem.id
				this.$refs.kpiIndex.modal_show()
			},
			addNode() {
				this.nodeid = 0
				this.$refs.addIndex.modal_show()
			},
			editNode() {
				if (this.currentItem.id <= 0) {
					this.$message.error('根节点无法编辑')
					return
				}
				this.nodeid = this.currentItem.id
				this.$refs.addIndex.modal_show()
			},
			deleteNode() {
				if (this.currentItem.id <= 0) {
					this.$message.error('根节点无法删除')
					return
				}
				this.$confirm('是否确认删除【' + this.currentItem.name + '】').then(() => {
					this.$api.BIshopgoods.deletegroup({
						id: this.currentItem.id
					}).then(() => {
						this.list()
						this.$message.success('操作成功')
					})
				})
			},
			list() {
				this.loading = true
				this.shoplist = []
				this.$api.BIshopgoods.listgroup().then((res) => {
					this.sourceoperatedata = res.filter((item) => {
						return item.grouptype == 'operation'
					})
					let wlnshop = []
					let othershop = []
					let operation = []
					let root = [{
						id: -1,
						shopUid: -1,
						grouptype: 'shop',
						name: '店铺',
						selected: true,
						opened: true,
						children:[{
								id: -3,
								shopUid: -3,
								grouptype: 'shop',
								name: '万里牛',
								opened: true,
						},{
							id: -4,
							shopUid: -4,
							grouptype: 'shop',
							name: '纳智',
							opened: true,
						}]
					}, 
					// {
					// 	id: -2,
					// 	shopUid: -1,
					// 	grouptype: 'operation',
					// 	name: '分组',
					// 	selected: true,
					// 	opened: true,
					// },
					]
					res.forEach((item) => {
						if (item.grouptype == 'shop') {
							item.name = item.shopName
							if(item.platform=='wln'){
								wlnshop.push(item)
							}else{
								othershop.push(item)
							}
							
						}
						if (item.grouptype == 'operation') {
							if (item.adminstaffid) {
								item.name = item.shopName + '【' + window.systemMethods.getstaff(item
									.adminstaffid) + '】'
							} else {
								item.name = item.shopName
							}

							if (!item.parentid) {
								operation.push(item)
							} else {
								res.forEach((_item) => {
									if (_item.id == item.parentid) {
										_item.children = _item.children ? _item.children.push(
											item) : [item]
									}
								})
							}

						}
					})


					root[0].children[0].children = wlnshop
					root[0].children[1].children = othershop
					//root[1].children = operation
					this.operationItem = operation
					this.shoplist = root
					this.loading = false
				})
			},
			itemClick(e) {
				this.currentObj = e
				this.currentItem = e.model
				this.$emit('select', this.currentItem)
			},
			minutesSince(timestamp) {
				const givenTime = new Date(timestamp);
				const currentTime = new Date();
				const timeDifference = currentTime - givenTime;
				const minutesDifference = timeDifference / (1000 * 60);
				return Math.floor(minutesDifference);
			}

		},
		components: {
			VJstree,
			addIndex,
			importTable,
			kpiIndex
		}
	}
</script>